type DateLike = string | number | Date | null | undefined;

type FormatDateTimeOptions = {
  locale?: string;
  timeZone?: string;
  fallback?: string;
};

function toValidDate(value: DateLike): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (value === null || value === undefined) return null;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function resolveClientTimeZone(): string | undefined {
  if (!import.meta.client) return undefined;

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}

export function formatDateTime(
  value: DateLike,
  options: Intl.DateTimeFormatOptions,
  config: FormatDateTimeOptions = {},
): string {
  const date = toValidDate(value);
  if (!date) return config.fallback ?? "";

  const formatterOptions: Intl.DateTimeFormatOptions = {
    ...options,
    ...(config.timeZone ? { timeZone: config.timeZone } : {}),
  };

  return new Intl.DateTimeFormat(config.locale, formatterOptions).format(date);
}
